export enum BillingCycleStatusEnum {
  PENDING = "PENDING",
  PROCESSING = "PROCESSING",
  PROCESSING_ERROR = "PROCESSING_ERROR",
  PROCESSING_DELEGATION_ERROR = "PROCESSING_DELEGATION_ERROR",
  PROCESSING_PAYMENT = "PROCESSING_PAYMENT",
  WAITING_AUTHORIZATION_PIX_AUTO = "WAITING_AUTHORIZATION_PIX_AUTO",
  PAYMENT_ERROR = "PAYMENT_ERROR",
  PAST_DUE = "PAST_DUE",
  PAID = "PAID",
  CANCELED = "CANCELED",
  REFUNDED = "REFUNDED",
  PARTIAL_REFUNDED = "PARTIAL_REFUNDED",
  REVERSED = "REVERSED",
  PROCESSING_REFUNDING = "PROCESSING_REFUNDING",
  PROCESSING_REVERSING = "PROCESSING_REVERSING",
  REFUND_FAILED = "REFUND_FAILED",
  REVERSED_FAILED = "REVERSED_FAILED",
  SCHEDULED_RETRY = "SCHEDULED_RETRY",
  PAYMENT_DENIED = "PAYMENT_DENIED",
  UPDATED = "UPDATED",
  PROCESSING_DELEGATION = "PROCESSING_DELEGATION",
  CANCELED_BY_DELEGATE_UPDATE = "CANCELED_BY_DELEGATE_UPDATE",
  CANCELED_BY_AMOUNT_UPDATE = "CANCELED_BY_AMOUNT_UPDATE",
}
export const billingCycleStatusLabels: Record<
  BillingCycleStatusEnum,
  string
> = {
  [BillingCycleStatusEnum.PENDING]:
    "Ciclo criado, aguardando processamento.",
  [BillingCycleStatusEnum.PROCESSING]:
    "Ciclo em processamento (validação e preparação para cobrança).",
  [BillingCycleStatusEnum.PROCESSING_ERROR]:
    "Erro genérico durante o processamento do ciclo.",
  [BillingCycleStatusEnum.PROCESSING_DELEGATION_ERROR]:
    "Erro ao processar delegação externa.",
  [BillingCycleStatusEnum.PROCESSING_PAYMENT]:
    "Ciclo em processamento de pagamento.",
  [BillingCycleStatusEnum.WAITING_AUTHORIZATION_PIX_AUTO]:
    "Ciclo aguardando autorização do Pix Automático pelo cliente.",
  [BillingCycleStatusEnum.PAYMENT_ERROR]:
    "Erro ocorrido durante o pagamento.",
  [BillingCycleStatusEnum.PAST_DUE]:
    "Ciclo vencido sem pagamento.",
  [BillingCycleStatusEnum.PAID]: "Ciclo pago com sucesso.",
  [BillingCycleStatusEnum.CANCELED]: "Ciclo cancelado.",
  [BillingCycleStatusEnum.REFUNDED]:
    "Ciclo totalmente reembolsado.",
  [BillingCycleStatusEnum.PARTIAL_REFUNDED]:
    "Ciclo parcialmente reembolsado.",
  [BillingCycleStatusEnum.REVERSED]: "Ciclo estornado.",
  [BillingCycleStatusEnum.PROCESSING_REFUNDING]:
    "Reembolso em processamento.",
  [BillingCycleStatusEnum.PROCESSING_REVERSING]:
    "Estorno em processamento.",
  [BillingCycleStatusEnum.REFUND_FAILED]:
    "Falha no reembolso.",
  [BillingCycleStatusEnum.REVERSED_FAILED]:
    "Falha no estorno.",
  [BillingCycleStatusEnum.SCHEDULED_RETRY]:
    "Ciclo agendado para repique.",
  [BillingCycleStatusEnum.PAYMENT_DENIED]:
    "Pagamento recusado.",
  [BillingCycleStatusEnum.UPDATED]:
    "Ciclo atualizado e aguardando novo processamento.",
  [BillingCycleStatusEnum.PROCESSING_DELEGATION]:
    "Processo de delegação em andamento.",
  [BillingCycleStatusEnum.CANCELED_BY_DELEGATE_UPDATE]:
    "Cancelado por atualização via delegado externo.",
  [BillingCycleStatusEnum.CANCELED_BY_AMOUNT_UPDATE]:
    "Cancelado por alteração no valor.",
}
export enum PaymentMethodNameEnum {
  BALANCE = "BALANCE",
  CREDIT_CARD = "CREDIT_CARD",
  DEBIT_CARD = "DEBIT_CARD",
  LOYALTY_POINTS = "LOYALTY_POINTS",
  GIFT_CARD_VTEX = "GIFT_CARD_VTEX",
  OPEN_FINANCE = "OPEN_FINANCE",
  BANK_SLIP = "BANK_SLIP",
  BOLEPIX = "BOLEPIX",
  DIRECT_DEBIT = "DIRECT_DEBIT",
  NUPAY = "NUPAY",
  PIX = "PIX",
  PIX_AUTO = "PIX_AUTO",
  CREDIT_CARD_PRE_APPROVAL = "CREDIT_CARD_PRE_APPROVAL",
}
export const paymentMethodLabels: Record<
  PaymentMethodNameEnum,
  string
> = {
  [PaymentMethodNameEnum.BALANCE]: "Saldo",
  [PaymentMethodNameEnum.CREDIT_CARD]: "Cartão de Crédito",
  [PaymentMethodNameEnum.DEBIT_CARD]: "Cartão de Débito",
  [PaymentMethodNameEnum.LOYALTY_POINTS]:
    "Pontos de Fidelização",
  [PaymentMethodNameEnum.GIFT_CARD_VTEX]: "Vale-Presente",
  [PaymentMethodNameEnum.OPEN_FINANCE]:
    "Iniciador Open Finance",
  [PaymentMethodNameEnum.BANK_SLIP]: "Boleto Bancário",
  [PaymentMethodNameEnum.BOLEPIX]: "Boleto + Pix",
  [PaymentMethodNameEnum.DIRECT_DEBIT]: "Débito em Conta",
  [PaymentMethodNameEnum.NUPAY]: "Nupay",
  [PaymentMethodNameEnum.PIX]: "Pix",
  [PaymentMethodNameEnum.PIX_AUTO]: "Pix Automático",
  [PaymentMethodNameEnum.CREDIT_CARD_PRE_APPROVAL]:
    "Pré-Autorização de Cartão de Crédito",
}
export enum StatusTrackingEnum {
  PENDING = "PENDING",
  FUTURE = "FUTURE",
  PRE_AUTHORIZATION_WAITING = "PRE_AUTHORIZATION_WAITING",
  PRE_AUTHORIZATION_ERROR = "PRE_AUTHORIZATION_ERROR",
  PRE_AUTHORIZATION_TIMEOUT_ERROR = "PRE_AUTHORIZATION_TIMEOUT_ERROR",
  PRE_AUTHORIZED_BY_GATEWAY = "PRE_AUTHORIZED_BY_GATEWAY",
  WAITING_PAYMENT = "WAITING_PAYMENT",
  WAITING_PARTIAL_PAYMENT = "WAITING_PARTIAL_PAYMENT",
  WAITING_PAYMENT_PIX = "WAITING_PAYMENT_PIX",
  WAITING_PAYMENT_BANK_SLIP = "WAITING_PAYMENT_BANK_SLIP",
  WAITING_PAYMENT_BOLEPIX = "WAITING_PAYMENT_BOLEPIX",
  WAITING_PAYMENT_DIRECT_DEBIT = "WAITING_PAYMENT_DIRECT_DEBIT",
  WAITING_PAYMENT_DIRECT_DEBIT_SCHEDULED = "WAITING_PAYMENT_DIRECT_DEBIT_SCHEDULED",
  AUTHORIZATION_TIMEOUT_ERROR = "AUTHORIZATION_TIMEOUT_ERROR",
  PAYMENT_IDENTIFIED = "PAYMENT_IDENTIFIED",
  CONFIRMED = "CONFIRMED",
  CANCELED_BY_GATEWAY = "CANCELED_BY_GATEWAY",
  CANCELED_BY_STORE = "CANCELED_BY_STORE",
  CANCELED_BY_CUSTOMER = "CANCELED_BY_CUSTOMER",
  EXPIRED = "EXPIRED",
  SUBMITTED_FOR_REVERSED = "SUBMITTED_FOR_REVERSED",
  REVERSED = "REVERSED",
  REVERSED_FAILED = "REVERSED_FAILED",
  SUBMITTED_FOR_REFUND = "SUBMITTED_FOR_REFUND",
  REFUNDED = "REFUNDED",
  PARTIAL_REFUNDED = "PARTIAL_REFUNDED",
  REFUND_FAILED = "REFUND_FAILED",
  REFUND_PENDING = "REFUND_PENDING",
  REFUND_CANCELED = "REFUND_CANCELED",
  ERROR = "ERROR",
}

export enum SalesChannelEnum {
  INSURANCE = "INSURANCE",
  VTEX_PLATFORM = "VTEX_PLATFORM",
  POS = "POS",
  ANDROID_APP = "ANDROID_APP",
  ON_LINE = "ON_LINE",
  ADMIN = "ADMIN",
  SUBSCRIPTION = "SUBSCRIPTION",
  VTEX_SUBSCRIPTION = "VTEX_SUBSCRIPTION",
}
export const salesChannelLabels: Record<
  SalesChannelEnum,
  string
> = {
  [SalesChannelEnum.INSURANCE]: "Seguro",
  [SalesChannelEnum.VTEX_PLATFORM]: "Plataforma VTEX",
  [SalesChannelEnum.POS]: "Ponto de Venda (POS)",
  [SalesChannelEnum.ANDROID_APP]: "Aplicativo Android",
  [SalesChannelEnum.ON_LINE]: "Online",
  [SalesChannelEnum.ADMIN]: "Administração",
  [SalesChannelEnum.SUBSCRIPTION]: "Assinatura",
  [SalesChannelEnum.VTEX_SUBSCRIPTION]: "Assinatura VTEX",
}
export enum FilterOrderStatusEnum {
  ALL = "ALL",
  CANCELED = "CANCELED",
  PENDING = "PENDING",
  FINISHED = "FINISHED",
}

export enum GenericStatusEnum {
  PENDING = "PENDING",
  // Buckets genéricos enviados pelo backend (Java GenericStatus).
  // FINISHED = pagamento efetivado (exibido como "Pago"); SETTLEMENT = "Liquidado".
  FINISHED = "FINISHED",
  SETTLEMENT = "SETTLEMENT",
  PAID = "PAID",
  CANCELED = "CANCELED",
  REFUNDED = "REFUNDED",
  PAYMENT_IDENTIFIED = "PAYMENT_IDENTIFIED",
  FAILURE = "FAILURE",
  WAITING_PAYMENT = "WAITING_PAYMENT",
  PAYMENT_DENIED = "PAYMENT_DENIED",
  EXPIRED = "EXPIRED",
  REVERSED = "REVERSED",
  FUTURE = "FUTURE",
}

export const statusToGenericStatus: Record<
  StatusTrackingEnum,
  GenericStatusEnum
> = {
  [StatusTrackingEnum.PENDING]: GenericStatusEnum.PENDING,
  [StatusTrackingEnum.FUTURE]: GenericStatusEnum.FUTURE,
  [StatusTrackingEnum.PRE_AUTHORIZATION_WAITING]:
    GenericStatusEnum.PENDING,
  [StatusTrackingEnum.PRE_AUTHORIZATION_ERROR]:
    GenericStatusEnum.FAILURE,
  [StatusTrackingEnum.PRE_AUTHORIZATION_TIMEOUT_ERROR]:
    GenericStatusEnum.FAILURE,
  [StatusTrackingEnum.PRE_AUTHORIZED_BY_GATEWAY]:
    GenericStatusEnum.PENDING,
  [StatusTrackingEnum.WAITING_PAYMENT]:
    GenericStatusEnum.WAITING_PAYMENT,
  [StatusTrackingEnum.WAITING_PARTIAL_PAYMENT]:
    GenericStatusEnum.WAITING_PAYMENT,
  [StatusTrackingEnum.WAITING_PAYMENT_PIX]:
    GenericStatusEnum.WAITING_PAYMENT,
  [StatusTrackingEnum.WAITING_PAYMENT_BANK_SLIP]:
    GenericStatusEnum.WAITING_PAYMENT,
  [StatusTrackingEnum.WAITING_PAYMENT_BOLEPIX]:
    GenericStatusEnum.WAITING_PAYMENT,
  [StatusTrackingEnum.WAITING_PAYMENT_DIRECT_DEBIT]:
    GenericStatusEnum.WAITING_PAYMENT,
  [StatusTrackingEnum.WAITING_PAYMENT_DIRECT_DEBIT_SCHEDULED]:
    GenericStatusEnum.WAITING_PAYMENT,
  [StatusTrackingEnum.AUTHORIZATION_TIMEOUT_ERROR]:
    GenericStatusEnum.FAILURE,
  [StatusTrackingEnum.PAYMENT_IDENTIFIED]:
    GenericStatusEnum.PAYMENT_IDENTIFIED,
  [StatusTrackingEnum.CONFIRMED]: GenericStatusEnum.PAID,
  [StatusTrackingEnum.CANCELED_BY_GATEWAY]:
    GenericStatusEnum.PAYMENT_DENIED,
  [StatusTrackingEnum.CANCELED_BY_STORE]:
    GenericStatusEnum.CANCELED,
  [StatusTrackingEnum.CANCELED_BY_CUSTOMER]:
    GenericStatusEnum.CANCELED,
  [StatusTrackingEnum.EXPIRED]: GenericStatusEnum.EXPIRED,
  [StatusTrackingEnum.SUBMITTED_FOR_REVERSED]:
    GenericStatusEnum.PENDING,
  [StatusTrackingEnum.REVERSED]: GenericStatusEnum.REVERSED,
  [StatusTrackingEnum.REVERSED_FAILED]:
    GenericStatusEnum.FAILURE,
  [StatusTrackingEnum.SUBMITTED_FOR_REFUND]:
    GenericStatusEnum.PENDING,
  [StatusTrackingEnum.REFUNDED]: GenericStatusEnum.REFUNDED,
  [StatusTrackingEnum.PARTIAL_REFUNDED]:
    GenericStatusEnum.REFUNDED,
  [StatusTrackingEnum.REFUND_FAILED]:
    GenericStatusEnum.FAILURE,
  [StatusTrackingEnum.REFUND_PENDING]:
    GenericStatusEnum.PENDING,
  [StatusTrackingEnum.REFUND_CANCELED]:
    GenericStatusEnum.PENDING,
  [StatusTrackingEnum.ERROR]: GenericStatusEnum.FAILURE,
}
